// import { Component } from '@theme/component';

// class NavigationMobile extends Component {
//   requiredRefs = ['firstLevelLinks', 'secondLevelGroups'];

//   connectedCallback() {
//     super.connectedCallback();
//   }

//   /**
//    * @param {MouseEvent & {target: HTMLElement}} event
//    */
//   handleClickFirstLevel(event) {
//     event.preventDefault();

//     const clickedLink = event.target;
//     const linkDataIndex = clickedLink.getAttribute('data-index');

//     if (!linkDataIndex) {
//       return;
//     }

//     // Remove is-active class from all second level groups
//     for (const group of this.refs.secondLevelGroups) {
//       group.classList.remove('is-active');
//     }

//     // Find and activate the corresponding second level group by data-index
//     let targetGroup = null;
//     for (const group of this.refs.secondLevelGroups) {
//       if (group.getAttribute('data-index') === linkDataIndex) {
//         targetGroup = group;
//         break;
//       }
//     }

//     if (targetGroup) {
//       targetGroup.classList.add('is-active');
//       this.classList.add('is-second-level-active');
//     }
//   }

//   /**
//    * @param {MouseEvent & {target: HTMLElement}} event
//    */
//   handleClickSecondLevel(event) {
//     event.preventDefault();

//     const clickedLink = event.target;
//     const linkDataIndex = clickedLink.getAttribute('data-index');

//     if (!linkDataIndex) {
//       return;
//     }

//     // Remove is-active class from all third level groups
//     for (const group of this.refs.thirdLevelGroups) {
//       group.classList.remove('is-active');
//     }

//     // Find and activate the corresponding third level group by data-index
//     let targetGroup = null;
//     for (const group of this.refs.thirdLevelGroups) {
//       if (group.getAttribute('data-index') === linkDataIndex) {
//         targetGroup = group;
//         break;
//       }
//     }

//     if (targetGroup) {
//       targetGroup.classList.add('is-active');
//       this.classList.add('is-third-level-active');
//     }
//   }

//   /**
//    * @param {MouseEvent & {target: HTMLElement}} event
//    */
//   handleClickBackSecondLevel(event) {
//     event.preventDefault();

//     for (const group of this.refs.secondLevelGroups) {
//       group.classList.remove('is-active');
//     }

//     this.classList.remove('is-second-level-active');
//   }

//   /**
//    * @param {MouseEvent & {target: HTMLElement}} event
//    */
//   handleClickBackThirdLevel(event) {
//     event.preventDefault();

//     for (const group of this.refs.thirdLevelGroups) {
//       group.classList.remove('is-active');
//     }

//     this.classList.remove('is-third-level-active');
//   }
// }

// if (!customElements.get('navigation-mobile')) {
//   customElements.define('navigation-mobile', NavigationMobile);
// }

// class NavigationDesktop extends Component {
//   requiredRefs = ['firstLevelLinks', 'secondLevel', 'secondLevelGroups'];

//   /** @type {number} */
//   #activeDropdownIndex = -1;
//   /** @type {number} */
//   #activeLinkIndex = -1;
//   /** @type {number | null} */
//   #hideTimeout = null;
//   /** @type {number} */
//   #timeoutDuration = 50;

//   connectedCallback() {
//     super.connectedCallback();
//   }

//   /**
//    * @param {PointerEvent & {target: HTMLElement}} event
//    */
//   handlePointerEnter(event) {
//     event.preventDefault();

//     const linkElement = event.target;
//     const linkIndex = this.refs.firstLevelLinks.indexOf(linkElement);
//     const correspondingGroup = this.refs.secondLevelGroups[linkIndex];

//     if (linkIndex < 0 || linkIndex >= this.refs.secondLevelGroups.length)
//       return;

//     // Only show dropdown if this link has a corresponding second-level group with children
//     if (
//       correspondingGroup &&
//       correspondingGroup.firstElementChild &&
//       correspondingGroup.firstElementChild.children.length > 0
//     ) {
//       setTimeout(() => {
//         if (
//           this.#activeDropdownIndex !== -1 &&
//           this.#activeDropdownIndex !== linkIndex
//         )
//           return;

//         this.#activeLinkIndex = linkIndex;
//         this.#showDropdown(linkIndex);
//         this.#clearAllUnderlines();
//         linkElement.style.textDecoration = 'underline';
//       }, this.#timeoutDuration);
//     }
//   }

//   /**
//    * @param {PointerEvent & {target: HTMLElement}} event
//    */
//   handlePointerLeave(event) {
//     event.preventDefault();

//     const linkElement = event.target;
//     const linkIndex = this.refs.firstLevelLinks.indexOf(linkElement);

//     if (
//       this.#activeDropdownIndex !== -1 &&
//       this.#activeDropdownIndex !== linkIndex
//     )
//       return;

//     this.#hideTimeout = setTimeout(() => {
//       this.#hideDropdown();
//     }, this.#timeoutDuration);
//   }

//   /**
//    * Show dropdown for specific link index
//    * @param {number} index
//    */
//   #showDropdown(index) {
//     // Clear any pending hide timeout
//     if (this.#hideTimeout) {
//       clearTimeout(this.#hideTimeout);
//       this.#hideTimeout = null;
//     }

//     // Hide current dropdown if different
//     if (this.#activeDropdownIndex !== index) {
//       this.#hideDropdown();
//     }

//     this.#activeDropdownIndex = index;

//     // Hide all groups first
//     for (const group of this.refs.secondLevelGroups) {
//       group.style.display = 'none';
//     }

//     // Show the selected group only if it has children
//     const targetGroup = this.refs.secondLevelGroups[index];
//     if (targetGroup && targetGroup.children.length > 0) {
//       targetGroup.style.display = 'flex';

//       // Show the second level container
//       this.refs.secondLevel.style.gridTemplateRows = '1fr';
//       this.refs.secondLevel.style.opacity = '1';
//       this.refs.secondLevel.style.visibility = 'visible';
//     }
//   }

//   /**
//    * @param {PointerEvent} event
//    */
//   handleDropdownEnter(event) {
//     // Cancel any pending hide timeout when entering dropdown area
//     if (this.#hideTimeout) {
//       clearTimeout(this.#hideTimeout);
//       this.#hideTimeout = null;
//     }
//   }

//   /**
//    * @param {PointerEvent} event
//    */
//   handleDropdownLeave(event) {
//     // Clear underlines and hide dropdown when leaving the dropdown area
//     this.#hideTimeout = setTimeout(() => {
//       this.#clearAllUnderlines();
//       this.#hideDropdown();
//     }, this.#timeoutDuration);
//   }

//   /**
//    * Clear underlines from all first-level links
//    */
//   #clearAllUnderlines() {
//     for (const link of this.refs.firstLevelLinks) {
//       link.style.textDecoration = '';
//     }
//     this.#activeLinkIndex = -1;
//   }

//   /**
//    * Hide dropdown
//    */
//   #hideDropdown() {
//     this.#activeDropdownIndex = -1;

//     for (const group of this.refs.secondLevelGroups) {
//       group.style.display = 'none';
//     }

//     this.refs.secondLevel.style.gridTemplateRows = '0fr';
//     this.refs.secondLevel.style.opacity = '0';
//     this.refs.secondLevel.style.visibility = 'hidden';

//     this.#clearAllUnderlines();
//   }
// }

// if (!customElements.get('navigation-desktop')) {
//   customElements.define('navigation-desktop', NavigationDesktop);
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const navigationMobileToggleButtons = document.querySelectorAll(
//     '[data-navigation-mobile-toggle]'
//   );
//   const searchDrawerOpenButtons = document.querySelectorAll(
//     '[data-search-drawer-open]'
//   );

//   navigationMobileToggleButtons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       if (document.body.classList.contains('is-navigation-mobile-open')) {
//         document.body.classList.remove('is-navigation-mobile-open');
//         document.body.removeAttribute('data-lock-scroll');
//       } else {
//         document.body.classList.add('is-navigation-mobile-open');
//         document.body.setAttribute('data-lock-scroll', 'true');
//       }
//     });
//   });

//   searchDrawerOpenButtons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       document.body.classList.add('is-search-drawer-open');
//       document.body.setAttribute('data-lock-scroll', 'true');
//     });
//   });
// });

// Old code above (menu was sticking so it was replaced)

import { Component } from '@theme/component';

class NavigationMobile extends Component {
  requiredRefs = ['firstLevelLinks', 'secondLevelGroups'];

  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * @param {MouseEvent & {target: HTMLElement}} event
   */
  handleClickFirstLevel(event) {
    event.preventDefault();

    const clickedLink = event.target;
    const linkDataIndex = clickedLink.getAttribute('data-index');

    if (!linkDataIndex) {
      return;
    }

    // Remove is-active class from all second level groups
    for (const group of this.refs.secondLevelGroups) {
      group.classList.remove('is-active');
    }

    // Find and activate the corresponding second level group by data-index
    let targetGroup = null;
    for (const group of this.refs.secondLevelGroups) {
      if (group.getAttribute('data-index') === linkDataIndex) {
        targetGroup = group;
        break;
      }
    }

    if (targetGroup) {
      targetGroup.classList.add('is-active');
      this.classList.add('is-second-level-active');
    }
  }

  /**
   * @param {MouseEvent & {target: HTMLElement}} event
   */
  handleClickSecondLevel(event) {
    event.preventDefault();

    const clickedLink = event.target;
    const linkDataIndex = clickedLink.getAttribute('data-index');

    if (!linkDataIndex) {
      return;
    }

    // Remove is-active class from all third level groups
    for (const group of this.refs.thirdLevelGroups) {
      group.classList.remove('is-active');
    }

    // Find and activate the corresponding third level group by data-index
    let targetGroup = null;
    for (const group of this.refs.thirdLevelGroups) {
      if (group.getAttribute('data-index') === linkDataIndex) {
        targetGroup = group;
        break;
      }
    }

    if (targetGroup) {
      targetGroup.classList.add('is-active');
      this.classList.add('is-third-level-active');
    }
  }

  /**
   * @param {MouseEvent & {target: HTMLElement}} event
   */
  handleClickBackSecondLevel(event) {
    event.preventDefault();

    for (const group of this.refs.secondLevelGroups) {
      group.classList.remove('is-active');
    }

    this.classList.remove('is-second-level-active');
  }

  /**
   * @param {MouseEvent & {target: HTMLElement}} event
   */
  handleClickBackThirdLevel(event) {
    event.preventDefault();

    for (const group of this.refs.thirdLevelGroups) {
      group.classList.remove('is-active');
    }

    this.classList.remove('is-third-level-active');
  }
}

if (!customElements.get('navigation-mobile')) {
  customElements.define('navigation-mobile', NavigationMobile);
}

class NavigationDesktop extends Component {
  requiredRefs = ['firstLevelLinks', 'secondLevel', 'secondLevelGroups'];

  /** @type {number} */
  #activeDropdownIndex = -1;
  /** @type {number} */
  #activeLinkIndex = -1;
  /** @type {number | null} */
  #hideTimeout = null;
  /** @type {number} */
  #timeoutDuration = 400;

  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * @param {PointerEvent & {target: HTMLElement}} event
   */
  // Code commented and replaced by code below as menu sticking and clunky
  // handlePointerEnter(event) {
  //   event.preventDefault();

  //   const linkElement = event.target;
  //   const linkIndex = this.refs.firstLevelLinks.indexOf(linkElement);
  //   const correspondingGroup = this.refs.secondLevelGroups[linkIndex];

  //   if (linkIndex < 0 || linkIndex >= this.refs.secondLevelGroups.length)
  //     return;

  //   // Only show dropdown if this link has a corresponding second-level group with children
  //   if (
  //     correspondingGroup &&
  //     correspondingGroup.firstElementChild &&
  //     correspondingGroup.firstElementChild.children.length > 0
  //   ) {
  //     setTimeout(() => {
  //       if (
  //         this.#activeDropdownIndex !== -1 &&
  //         this.#activeDropdownIndex !== linkIndex
  //       )
  //         return;

  //       this.#activeLinkIndex = linkIndex;
  //       this.#showDropdown(linkIndex);
  //       this.#clearAllUnderlines();
  //       linkElement.style.textDecoration = 'underline';
  //     }, this.#timeoutDuration);
  //   }
  // }
    handlePointerEnter(event) {
  event.preventDefault();

  const linkElement = event.target;
  const linkIndex = this.refs.firstLevelLinks.indexOf(linkElement);
  const correspondingGroup = this.refs.secondLevelGroups[linkIndex];

  if (linkIndex < 0 || linkIndex >= this.refs.secondLevelGroups.length) {
    return;
  }

  // Only show dropdown if this link has a corresponding second-level group with children
  if (
    correspondingGroup &&
    correspondingGroup.firstElementChild &&
    correspondingGroup.firstElementChild.children.length > 0
  ) {
    if (this.#hideTimeout) {
      clearTimeout(this.#hideTimeout);
      this.#hideTimeout = null;
    }

    this.#activeLinkIndex = linkIndex;
    this.#showDropdown(linkIndex);
    this.#clearAllUnderlines();
    linkElement.style.textDecoration = 'underline';
  }
}

  /**
   * @param {PointerEvent & {target: HTMLElement}} event
   */
  handlePointerLeave(event) {
    event.preventDefault();

    const linkElement = event.target;
    const linkIndex = this.refs.firstLevelLinks.indexOf(linkElement);

    if (
      this.#activeDropdownIndex !== -1 &&
      this.#activeDropdownIndex !== linkIndex
    )
      return;

    this.#hideTimeout = setTimeout(() => {
      this.#hideDropdown();
    }, this.#timeoutDuration);
  }

  /**
   * Show dropdown for specific link index
   * @param {number} index
   */
  #showDropdown(index) {
    // Clear any pending hide timeout
    if (this.#hideTimeout) {
      clearTimeout(this.#hideTimeout);
      this.#hideTimeout = null;
    }

    // Hide current dropdown if different
    if (this.#activeDropdownIndex !== index) {
      this.#hideDropdown();
    }

    this.#activeDropdownIndex = index;

    // Hide all groups first
    for (const group of this.refs.secondLevelGroups) {
      group.style.display = 'none';
    }

    // Show the selected group only if it has children
    const targetGroup = this.refs.secondLevelGroups[index];
    if (targetGroup && targetGroup.children.length > 0) {
      targetGroup.style.display = 'flex';

      // Show the second level container
      this.refs.secondLevel.style.gridTemplateRows = '1fr';
      this.refs.secondLevel.style.opacity = '1';
      this.refs.secondLevel.style.visibility = 'visible';
    }
  }

  /**
   * @param {PointerEvent} event
   */
  handleDropdownEnter(event) {
    // Cancel any pending hide timeout when entering dropdown area
    if (this.#hideTimeout) {
      clearTimeout(this.#hideTimeout);
      this.#hideTimeout = null;
    }
  }

  /**
   * @param {PointerEvent} event
   */
  handleDropdownLeave(event) {
    // Clear underlines and hide dropdown when leaving the dropdown area
    this.#hideTimeout = setTimeout(() => {
      this.#clearAllUnderlines();
      this.#hideDropdown();
    }, this.#timeoutDuration);
  }

  /**
   * Clear underlines from all first-level links
   */
  #clearAllUnderlines() {
    for (const link of this.refs.firstLevelLinks) {
      link.style.textDecoration = '';
    }
    this.#activeLinkIndex = -1;
  }

  /**
   * Hide dropdown
   */
  #hideDropdown() {
    this.#activeDropdownIndex = -1;

    for (const group of this.refs.secondLevelGroups) {
      group.style.display = 'none';
    }

    this.refs.secondLevel.style.gridTemplateRows = '0fr';
    this.refs.secondLevel.style.opacity = '0';
    this.refs.secondLevel.style.visibility = 'hidden';

    this.#clearAllUnderlines();
  }
}

if (!customElements.get('navigation-desktop')) {
  customElements.define('navigation-desktop', NavigationDesktop);
}

document.addEventListener('DOMContentLoaded', () => {
  const navigationMobileToggleButtons = document.querySelectorAll(
    '[data-navigation-mobile-toggle]'
  );
  const searchDrawerOpenButtons = document.querySelectorAll(
    '[data-search-drawer-open]'
  );

  navigationMobileToggleButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('is-navigation-mobile-open')) {
        document.body.classList.remove('is-navigation-mobile-open');
        document.body.removeAttribute('data-lock-scroll');
      } else {
        document.body.classList.add('is-navigation-mobile-open');
        document.body.setAttribute('data-lock-scroll', 'true');
      }
    });
  });

  searchDrawerOpenButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('is-search-drawer-open');
      document.body.setAttribute('data-lock-scroll', 'true');
    });
  });
});